import script from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalaryManagement.vue?vue&type=style&index=0&id=e534da60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e534da60"]])

export default __exports__